export function Footer() {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-20 bg-white/90 backdrop-blur-sm border-t border-zinc-100 px-4 py-1 text-center pointer-events-none">
      <p className="text-[10px] text-zinc-400 leading-tight">
        Desarrollo y Soporte técnico: <span className="font-medium">Tomás Hirata</span> · 2288471996
      </p>
    </div>
  );
}
